// import { connect } from 'react-redux';
// import { reduxForm } from 'redux-form';

import { PARTNER_BANNER_ROUTER_ROOT } from './constants';
import PartnerBannerForm from './PartnerBannerForm';

const router = {
  path: PARTNER_BANNER_ROUTER_ROOT,
  component: PartnerBannerForm
};


export default {
  router
}



// WEBPACK FOOTER //
// ./src/components/Partner/index.js